"use strict";

exports.__esModule = true;

exports.default = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-link/~/babel-runtime/helpers/objectWithoutProperties.js
// module id = ./node_modules/gatsby-link/node_modules/babel-runtime/helpers/objectWithoutProperties.js
// module chunks = 168707334958949